// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginPage_wrapper__rI2E+","container":"LoginPage_container__U+RQH","Login":"LoginPage_Login__7Ca7e","Title":"LoginPage_Title__frGNV"};